import { MeetingFilterModel } from "Meetings/models/MeetingFilterModel";
import { MeetingDetailModel } from "models/MeetingDetailModel";
import { createContext } from "react";

export interface MeetingsContextProps {
  // Filter + pagination state (unified)
  query: MeetingFilterModel;
  setQuery: (query: MeetingFilterModel) => void;
  resetQuery: () => void;

  // Data state
  isLoading: boolean;
  results: MeetingDetailModel[];
  totalFiltered: number;
  totalUnfiltered: number;

  // UI state
  showAdditionalData: boolean;
  colSpan: number;
  showAddForm: boolean;
  setShowAddForm: (isAdding: boolean) => void;

  // Actions
  reloadMeetings: () => Promise<unknown>;
}

export const MeetingsContext = createContext({} as MeetingsContextProps);
